export default "__VITE_ASSET__5213b004__"